import React, { Fragment, FunctionComponent } from "react";

import { LOC_KEY_QUICK_ACCESS_MENU_FAVORITES, LOC_KEY_QUICK_ACCESS_MENU_HISTORY_ITEMS, LOC_KEY_QUICK_ACCESS_MENU_OPENED_ITEMS } from "../../locKeys";
import { hasOpenedFormsHistoryCountSet } from "../../utils";
import { GroupHeader } from "../GroupHeader";
import { QuickAccessFavoriteItems } from "../QuickAccessFavoriteItems";
import { QuickAccessGroupHeaderLayout } from "../QuickAccessGroupHeaderLayout";
import { QuickAccessHistoryItems } from "../QuickAccessHistoryItems";
import { QuickAccessOpenedItems } from "../QuickAccessOpenedItems";

/** Obsah pro menu Rychlého přístupu v případě neaktivního vyhledávání. */
export const QuickAccessContent: FunctionComponent = () => (
    <Fragment>
        <QuickAccessGroupHeaderLayout>
            <GroupHeader locKey={LOC_KEY_QUICK_ACCESS_MENU_OPENED_ITEMS}/>
        </QuickAccessGroupHeaderLayout>
        <QuickAccessOpenedItems/>
        {
            hasOpenedFormsHistoryCountSet() &&
            <Fragment>
                <QuickAccessGroupHeaderLayout>
                    <GroupHeader locKey={LOC_KEY_QUICK_ACCESS_MENU_HISTORY_ITEMS}/>
                </QuickAccessGroupHeaderLayout>
                <QuickAccessHistoryItems/>
            </Fragment>
        }
        <QuickAccessGroupHeaderLayout>
            <GroupHeader locKey={LOC_KEY_QUICK_ACCESS_MENU_FAVORITES}/>
        </QuickAccessGroupHeaderLayout>
        <QuickAccessFavoriteItems/>
    </Fragment>
);
